import type { Models } from "appwrite";

export const QUALIFICATION_TYPES = [
    { value: "DQ", label: "DQ — Calificación de Diseño" },
    { value: "IQ", label: "IQ — Calificación de Instalación" },
    { value: "OQ", label: "OQ — Calificación Operacional" },
    { value: "PQ", label: "PQ — Calificación de Desempeño" },
    { value: "RE_IQ", label: "Re-IQ — Recalificación de Instalación" },
    { value: "RE_OQ", label: "Re-OQ — Recalificación Operacional" },
    { value: "RE_PQ", label: "Re-PQ — Recalificación de Desempeño" },
] as const;


export type ServiceType =
    | "instalacion"
    | "preventivo"
    | "correctivo"
    | "calificacion-validacion"
    | "capacitacion"
    | "otro";

export type FinalStatus =
    | "operativo"
    | "operativo_observaciones"
    | "fuera_servicio";

// Each entry in idAttachments is either a plain fileId (legacy) or
// JSON: {"id":"fileId","description":"texto"}
export interface AttachmentEntry { id: string; description: string }

export function parseAttachment(raw: string): AttachmentEntry {
    try {
        const p = JSON.parse(raw)
        if (p?.id) return { id: p.id, description: p.description ?? "" }
    } catch { /* legacy plain fileId */ }
    return { id: raw, description: "" }
}

export function serializeAttachment(id: string, description: string): string {
    return JSON.stringify({ id, description })
}


export interface ServiceReport extends Models.Document {
    idReport: string;
    serviceDate: string | null;
    reportDate: string | null;
    serviceStartTime: string | null;
    serviceEndTime: string | null;
    serviceType: ServiceType | null;
    purchaseOrder: string | null;
    engineerId: string | null;
    clientContact: string | null;
    clientArea: string | null;
    clientPosition: string | null;
    clientPhone: string | null;
    clientEmail: string | null;
    idInstrument: string;
    serviceReason: string | null;
    reasonDescription: string | null;
    qualificationType: string | null;
    finalStatus: FinalStatus | null;
    verifiedParameters: string[] | null;
    recommendations: string[] | null;
    nextMaintenanceData: string | null;
    requiresRemoteFollow: boolean;
    clientResponsible: string | null;
    clientResponsiblePosition: string | null;
    deliveredOperative: boolean;
    clientObservations: string[] | null;
    idAttachments: string[];
    documentReferences: string[] | null;
    serviceTypes: string[] | null;
    qualificationTypes: string[] | null;
    nextQualificationDate: string | null;
    status: "draft" | "final" | null;
    parentReportId: string | null;
    revisionNumber: string | null;
    internalNotes: string | null;
}



export interface ServiceReportForm {
    reportCode: string;
    serviceDate: string;
    reportDate: string;
    entryTime: string;
    exitTime: string;
    serviceTypes: ServiceType[];
    purchaseOrder: string;
    engineerId: string;
    clientName: string;
    clientRuc: string;
    clientAddress: string;
    clientContact: string;
    clientArea: string;
    clientPosition: string;
    clientPhone: string;
    clientEmail: string;
    idInstrument: string;
    equipmentSnapshot: string;
    clientCity: string;
    clientComercialName: string;
    serviceReason: string;
    qualificationTypes: string[];
    nextQualificationDate: string;
    reasonDescription: string;
    finalStatus: FinalStatus | "";
    verifiedParameters: string[];
    recommendations: string[];
    nextMaintenanceDate: string;
    requiresRemoteFollow: boolean;
    clientResponsible: string;
    clientResponsiblePosition: string;
    status: "draft" | "final" | null;
    parentReportId: string | null;
    revisionNumber: number | null;
    deliveredOperative: boolean;
    clientObservations: string;
    idAttachments: string[];
    documentReferences: string[];
    internalNotes: string;
}
